"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wireProtocol = exports.WireProtocol = void 0;
const api_1 = require("@cc-plugins/api");
const models_1 = require("@creature-chess/models");
const registry_1 = require("./registry");
const INBOUND_CHANNELS = [
    "gameEvents",
    "playerEvents",
    "playerInfoUpdates",
];
class WireProtocol {
    constructor(coreInbound, coreOutbound, registry) {
        this.coreInbound = coreInbound;
        this.coreOutbound = coreOutbound;
        this.registry = registry;
        this.base = new api_1.WireProtocolBase(INBOUND_CHANNELS, ["default"]);
        this.dirty = true;
        this.registry.onChange(() => {
            this.dirty = true;
        });
    }
    acceptsInbound(channel, type) {
        this.refresh();
        return this.base.acceptsInbound(channel, type);
    }
    acceptsOutbound(type) {
        this.refresh();
        return this.base.acceptsOutbound("default", type);
    }
    validateInbound(channel, type, payload) {
        this.refresh();
        return this.base.validateInbound(channel, type, payload);
    }
    refresh() {
        var _a, _b, _c, _d;
        if (!this.dirty) {
            return;
        }
        this.base.clear();
        for (const channel of INBOUND_CHANNELS) {
            for (const creator of this.coreInbound[channel]) {
                this.base.claimInbound(channel, creator, "core");
            }
        }
        for (const creator of this.coreOutbound) {
            this.base.claimOutbound("default", creator, "core");
        }
        for (const plugin of this.registry.list()) {
            const origin = { plugin: plugin.id };
            // The server may emit plugin outbound on any of the three inbound
            // channels, so claim plugin inbound on all of them.
            for (const creator of (_b = (_a = plugin.wire) === null || _a === void 0 ? void 0 : _a.inbound) !== null && _b !== void 0 ? _b : []) {
                for (const channel of INBOUND_CHANNELS) {
                    this.base.claimInbound(channel, creator, origin);
                }
            }
            for (const creator of (_d = (_c = plugin.wire) === null || _c === void 0 ? void 0 : _c.outbound) !== null && _d !== void 0 ? _d : []) {
                this.base.claimOutbound("default", creator, origin);
            }
        }
        this.dirty = false;
    }
}
exports.WireProtocol = WireProtocol;
exports.wireProtocol = new WireProtocol({
    gameEvents: models_1.gameEventCreators,
    playerEvents: models_1.wirePlayerEventCreators,
    playerInfoUpdates: models_1.playerInfoUpdateCreators,
}, models_1.playerActionCreators, registry_1.pluginRegistry);
